import { reducer as formReducer } from 'redux-form';

import { achievementsReducer } from '@/features/achievements';
import { activityReducer } from '@/features/activity';
import { forgotPasswordReducer, signInReducer } from '@/features/auth';
import { bridgeReducer } from '@/features/bridge';
import { onboardingReducer } from '@/features/onboarding';
import { progressReducer } from '@/features/progress';
import { stickersOnboardingReducer } from '@/features/stickers-onboarding';
import { wrappedReducer } from '@/features/wrapped';
import autonomyReducer from '@/pages/autonomy/Reducer';
import dailyGoalReducer from '@/pages/dailyGoal/Reducer';
import freePlayReducer from '@/pages/freePlay/Reducer';
import goalSettingsReducer from '@/pages/goalSettings/Reducer';
import learningPathReducer from '@/pages/learningPath/Reducer';
import reportReducer from '@/pages/report/Reducer';
import playlistReducer from '@/playlist/Reducer';
import sharedReducer from '@/shared/Reducer';

import dailyReportReducer from '@/components/dailyReport/Reducer';
import errorBoundaryReducer from '@/components/errorBoundary/Reducer';
import errorHandlerReducer from '@/components/errorHandler/Reducer';
import addImageModalReducer from '@/components/modals/addImage/Reducer';
import confirmationReducer from '@/components/modals/confirmation/Reducer';
import difficultyModalReducer from '@/components/modals/difficulty/Reducer';
import doubleTabsModalReducer from '@/components/modals/doubleTabsModal/Reducer';
import gameExplanationReducer from '@/components/modals/gameExplanation/Reducer';
import imagePreviewReducer from '@/components/modals/imagePreview/Reducer';
import mistakeInterventionReducer from '@/components/modals/mistakeIntervention/Reducer';
import offlineRetryModalReducer from '@/components/modals/offlineRetryModal/Reducer';
import parentPasswordModalReducer from '@/components/modals/parentPasswordModal/Reducer';
import videoModalReducer from '@/components/modals/videoModal/Reducer';
import notificationReducer from '@/components/notification/Reducer';
import notificationsReducer from '@/components/notifications/Reducer';
import onboardingMessagesReducer from '@/components/onboardingMessages/Reducer';
import playButtonReducer from '@/components/playButton/Reducer';

const rootReducer = () => {
	return {
		addImageModalReducer,
		confirmationReducer,
		errorBoundaryReducer,
		errorHandlerReducer,
		playlistReducer,
		forgotPasswordReducer,
		form: formReducer,
		gameExplanationReducer,
		imagePreviewReducer,
		notificationReducer,
		notificationsReducer,
		playButtonReducer,
		videoModalReducer,
		sharedReducer,
		signInReducer,
		onboardingReducer,
		reportReducer,
		goalSettingsReducer,
		learningPathReducer,
		dailyGoalReducer,
		stickersOnboardingReducer,
		difficultyModalReducer,
		dailyReportReducer,
		activityReducer,
		parentPasswordModalReducer,
		progressReducer,
		mistakeInterventionReducer,
		doubleTabsModalReducer,
		offlineRetryModalReducer,
		onboardingMessagesReducer,
		autonomyReducer,
		freePlayReducer,
		achievementsReducer,
		wrappedReducer,
		bridgeReducer,
	};
};

export default rootReducer;
